<template>
  <div class="peiso-modal peiso-bind">
    <div class="header-container">
        <span>Select Location</span>
    </div>

    <div class="body-container">
      <div class="field-group">
          <div>
              <el-select filterable v-model="selectedLocation" @change="onSelectLocation" placeholder="Select a Site" class="peiso-select-default w-100 m-bottom-1rem">
                  <el-option v-for="(item, i) in locationList" :key="`site-${i}`" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </div>
          <template  v-if="step == 1 && devices.length > 0">
              <div class="header-container m-top-1rem m-bottom-1rem">
                  <span>Select Terminals</span>
              </div>
              <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
              <div class="list-field-group" :class="{'d-flex align-items-center justify-content-center' : !devices.length}">
                  <template v-if="devices.length">
                      <div class="peiso-checkbox terminals checkbox-select-all mb-1" v-if="isPro">
                          <el-checkbox label="all" :disabled="!isPro" @change="checkedAllTerminal" :key="`checkbox-terminal-1`"  v-model="isCheckedTerminal">{{ isCheckedTerminal ? 'Unselect All' : 'Select All' }}</el-checkbox>
                      </div>
                      <el-checkbox-group v-model="selectedTerminals" class="peiso-checkbox terminals" @change="handleSelectedTerminals">

                          <el-checkbox v-for="(item, i) in devices" :key="`checkbox-${i}`" :label="item">{{ item.name }}</el-checkbox>
                      </el-checkbox-group>
                  </template>
                  <template v-else>
                      <span class="p-2">No terminals available for {{ selectedLocation.name }}. <br /> Please click 'Next' to continue.</span>
                  </template>
              </div>
              <span v-if="!selectedTerminals.length" class="errortext m-top-1rem">If no terminal is selected, the orders will not be filtered</span>

          </template>

          <template v-if="isPro && step == 2">
            <template v-if="categories.length">
                <div class="header-container m-top-1rem m-bottom-1rem">
                    <span>Select Revenue Group</span>
                </div>
                <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                <div class="list-field-group">
                    <el-checkbox-group :value="checkedRevenueGroup" class="peiso-checkbox">
                        <el-checkbox v-for="(item, i) in revenues"  @change="handleSelectedRevenue(item)" :key="`checkbox-revenue-${i}`" :label="item">{{ item }}</el-checkbox>
                    </el-checkbox-group>

                </div>
            </template>
        </template>


        <template v-if="isPro && step == 3">
          <template v-if="categories.length">
              <div class="header-container m-top-1rem m-bottom-1rem">
                  <span>Select Foods</span>
              </div>
              <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
              <div class="list-field-group">
                  <div class="peiso-checkbox checkbox-select-all mb-1" v-if="isPro">
                      <el-checkbox label="all" :disabled="!isPro" @change="checkedAllFood" :key="`checkbox-beverage-102`"  v-model="isCheckedFood">{{ isCheckedFood ? 'Unselect All' : 'Select All' }}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="checkedFood" class="peiso-checkbox" @change="handleSelectedFood">
                      <el-checkbox v-for="(item) in categories" :key="`checkbox-food-${item.id}`" :disabled="!isPro" :label="item">{{ item.name }}</el-checkbox>
                  </el-checkbox-group>
              </div>
          </template>
        </template>

        <template v-if="isPro && step == 4">
            <template v-if="categories.length">
              <div class="header-container m-top-1rem m-bottom-1rem">
                  <span>Select Beverages</span>
              </div>
              <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
              <div class="list-field-group">
                  <div class="peiso-checkbox checkbox-select-all  mb-1" v-if="isPro">
                      <el-checkbox label="all" :key="`checkbox-beverage-101`" :disabled="!isPro" @change="checkedAllBeverage" v-model="isCheckedBeverage">{{ isCheckedBeverage ? 'Unselect All' : 'Select All' }}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="checkedBeverage" class="peiso-checkbox" @change="handleSelectedBeverage">
                      <el-checkbox v-for="(item) in categories" :key="`checkbox-beverage-${item.id}`" :disabled="!isPro"  :label="item">{{ item.name }}</el-checkbox>
                  </el-checkbox-group>
              </div>
          </template>
        </template>

        <template>
          <div class="d-flex gap-10 m-top-1rem" v-if="isPro && !isComplete">
              <el-button :disabled="isLoading ? true : false" type="peiso-default" class="w-100" @click="back">Back</el-button>

              <template>
                  <el-button type="peiso-primary-pink" class="w-100" @click="next(step)" :disabled="this.selectedLocation ? false : true">Next</el-button>
              </template>
          </div>
          <div v-else class="d-flex gap-10 m-top-1rem">
              <el-button type="peiso-default"  class="w-100" :disabled="isLoading ? true : false" @click="back">Back</el-button>
              <el-button v-if="!isLoading" type="peiso-primary-pink" class="w-100" @click="confirmCompleteSquare">Confirm</el-button>
              <el-button v-if="isLoading" type="peiso-primary-pink" class="w-100"><i class="el-icon-loading"></i> Loading...</el-button>
          </div>
      </template>
      </div>
      </div>

  </div>
</template>

<script>
import api from '../../api/api';
import utils from '../../utils/utils';
export default {
  props: ['code'],
  data() {
    return {
      isComplete: false,
      locationList: [],
      categories: [],
      devices: [],
      step: 0,
      isLoading: false,
      selectedLocation: null,
      selectedTerminals: [],
      selectedFoods: [],
      selectedBeverages: [],
      validationMessage: '',
      isCheckedTerminal: false,
      isPro: true,
      checkedRevenueGroup: 'both',
      revenueGroupId: 'both',
      revenues: [
          'both',
          'food',
          'beverage'
      ],

      isCheckedFood: false,
      isCheckedBeverage: false,
      selectedFood: [],
      checkedFood: [],
      selectedBeverage: [],
      checkedBeverage: [],
    }
  },
  watch: {
    step () {
      if (this.step == 3 && this.revenueGroupId == 'food') {
        this.isComplete = true;
      } else if (this.step == 4 && this.revenueGroupId == 'beverage') {
        this.isComplete = true;
      } else if (this.step == 4 && this.revenueGroupId == 'both') {
        this.isComplete = true;
      } else {
        this.isComplete = false;
      }
    }
  },
  methods: {
    async confirmCompleteSquare() {
        this.isLoading = true
        if (!this.revenueGroupId) {
            this.validationMessage = 'Please select revenue group';
        } else if ((this.revenueGroupId == 'food' || this.revenueGroupId == 'both') && this.checkedFood.length <= 0) {
            this.validationMessage = 'Please select foods';
        } else if ((this.revenueGroupId == 'beverage' || this.revenueGroupId == 'both') && this.checkedBeverage.length <= 0) {
            this.validationMessage = 'Please select beverages';
        } else {
            let data = {
                locationId: this.selectedLocation,
                revenueGroup: this.revenueGroupId,
                devices: [],
                foodCategories: [],
                beverageCategories: [],
            };

            if (this.revenueGroupId == 'food' || this.revenueGroupId == 'both') {
                data.foodCategories = this.checkedFood;
            }

            if (this.revenueGroupId == 'beverage' || this.revenueGroupId == 'both') {
                data.beverageCategories = this.checkedBeverage;
            }

            if (this.selectedTerminals.length > 0) {
                data.devices = this.selectedTerminals;
            } 

            try {
                const res =  await api.squareCompleteBinding(data);
                
                this.isLoading = false

                if (res.data.code == 0) {
                    utils.alert2('', 'Successfully connected to square.', 'success')
                } else {
                    utils.alert2('', 'Error square binding configuration', 'error')
                }

                this.$emit('square-bind', data)

            } catch (err) {
                
                this.isLoading = false

                this.$emit('square-bind', data)

                if (err && err.response && err.response.data) {
                    utils.alert2('', err.response.data.message, 'error')
                }
            }
        
        }
    },
    handleSelectedTerminals(e) {
      this.selectedTerminals = e
      this.isCheckedTerminal = false
    },
    checkedAllTerminal () {
      if (!this.isCheckedTerminal) {
          this.selectedTerminals = [];
      } else {
          this.selectedTerminals = this.devices;
      }
    },

    checkedAllFood() {
        // this.isCheckedFood = !this.isCheckedFood;
        if (!this.isCheckedFood) {
            this.checkedFood = [];
        } else {
            this.checkedFood = this.categories;
        }
    },
    checkedAllBeverage() {
        if (!this.isCheckedBeverage) {
            this.checkedBeverage = [];
        } else {
            this.checkedBeverage = this.categories;
        }
    },

    handleSelectedFood(e) {
        this.checkedFood = e
        this.isCheckedFood = false;
    },

    handleSelectedRevenue(item) {
        this.checkedRevenueGroup = [item];
        this.revenueGroupId = item;
    },

    handleSelectedBeverage(e) {
        this.checkedBeverage = e;
        this.isCheckedBeverage = false;
    },
    async back () {
        if (this.step == 4 && this.revenueGroupId == 'beverage') {
            this.step = 2;
        } else if (this.step == 2 && this.devices.length <= 0) {
            this.step = 0;
        } else {
            this.step = this.step - 1;
        }

        if (this.step < 0) {
            await api.squareUnbinding();
            this.$emit('square-bind', null)
        }
    },

    next(step) {
        if (step == 0) {
            if (this.devices.length > 0) {
                this.step = 1;
            } else if (this.categories.length > 0) {
                this.step = 2;
            } else {
                this.validationMessage = 'Error fetching location data';
            }
        } else if (step == 1 && this.selectedTerminals.length <= 0) {
                this.validationMessage = 'Please select terminals';
        } else if (step == 2 && !this.revenueGroupId) {
                this.validationMessage = 'Please select revenue group';
        } else if (step == 3 && this.checkedFood.length <= 0) {
            this.validationMessage = 'Please select foods';
        } else if (step == 4 && this.checkedBeverage.length <= 0) {
            this.validationMessage = 'Please select beverages';
        } else {
            this.validationMessage = '';

            if (this.step == 2 && this.revenueGroupId == 'food') {
                this.step = 3
            } else if (this.step == 2 && this.revenueGroupId == 'beverage') {
                this.step = 4
            } else {
                this.step = (step + 1)
            }
        }
    },

    async getCategories (locationId) {
        const res = await api.getSquareCategories({locationId});

        if (res.data.code === 0) {
            this.categories = res.data.data;
        } else {
            // throw an error
            utils.alert2('', 'Error fetching categories', 'error');
        }
    },

    async getTerminals (locationId) {
        const res = await api.getSquareTerminals({locationId});
        if (res.data.code === 0) {
            this.devices = res.data.data;
        } else {
            // throw an error
            utils.alert2('', 'Error fetching terminals', 'error');
        }
    },

    async onSelectLocation (locationId) {

        this.loading = true;

        this.selectedLocation = locationId;

        await this.getCategories(locationId);
        await this.getTerminals(locationId);
     
        this.loading = false;
    },
  },
  async mounted() {
    if (this.code) {

      this.loading = true;

      try {
        const res = await api.squareBind({code: this.code});
       
        if (res.data.code === 0) {
            this.locationList = res.data.data;
            this.loading = false;
        } else {
            // throw an error
            this.loading = false;
            utils.alert2('', 'Error binding location', 'error');
        }
      } catch (error) {
        utils.alert2('', 'Something went wrong, please contact administrator.', 'error');
      }
      
    }
  }
}
</script>


<style lang="scss" scoped>
  @import '../../../static/scss/colors.scss';
  @import '../../../static/scss/fonts/fonts.scss';
    .mb-1 {
        margin-bottom: 10px;
    }
    .p-2 {
      padding: 10px !important;
      text-align: center !important;
    }
    .errortext {
        color: #ff4c30 !important;
        font-size: 13px !important;
        margin-bottom: 10px !important;
    }
    .checkbox-select-all {
        position: relative;
        left: 0;
        top: 0px;
        width: 100%;
        z-index: 50;
        background-color: var(--background-color-3);
        padding-top: 10px;
    }
    .peiso-bind {
        .el-button--peiso-default {
            > span {
                width: 100%;
            }
        }

        .el-dialog__headerbtn {
            display: none;
        }

        .list-grp-container {
            padding: 1rem;
        }

        .field-group {
            span {
                @include montserrat-font(14px, normal, 500, $white) {
                    margin-bottom: 10px;
                }
            }
        }

        .list-field-group {
            position: relative;
            min-height: 200px;
            max-height: 400px;
            overflow: hidden auto;
            border-radius: 5px;
            padding: 20px !important;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #434968;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #434968;
            }
            @include montserrat-font(14px, normal, 500, $white) {
                background-color: var(--background-color-3);
                padding: 10px;
            }
            .list-grp-container {

            }
        }

        .loading-container {
            position: absolute;
            left: 0px;
            top: 0px;
            height: 100%;
            background: var(--background-color-4);
            z-index: 60;
            border-radius: 10px;

            .loading-label-wrapper {
                padding: 2rem 2rem;
                box-shadow: 0 1px 3px rgba(0,0,0,.3);
                background-color: $gray2;

                @include montserrat-font(14px, normal, 500, $white);

                .loading {
                    font-size: 50px;
                }
            }
        }

        .terminals {
            .el-checkbox__inner {
                margin-bottom: 0px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modal/squareConfiguration.vue